<template>

  <div class="cliente-assigned-users">

    <div

      v-for="user in resolvedUsers"

      :key="user.id"

      class="cliente-assigned-users__row"

    >

      <div class="cliente-assigned-users__avatar-wrap">

        <img

          v-if="user.photoUrl"

          :src="user.photoUrl"

          :alt="user.displayName"

          class="cliente-assigned-users__avatar"

        />

        <div v-else class="cliente-assigned-users__avatar cliente-assigned-users__initials">

          {{ user.initials }}

        </div>

      </div>

      <span class="cliente-assigned-users__name">{{ user.displayName }}</span>

      <button

        type="button"

        class="cliente-assigned-users__remove"

        :title="t('common.delete')"

        @click="$emit('remove', user.id)"

      >

        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>

      </button>

    </div>

    <p v-if="!resolvedUsers.length" class="cliente-assigned-users__empty">{{ t('workspaceClienteModal.noUsers') }}</p>

    <button type="button" class="cliente-assigned-users__add" @click="$emit('assign')">

      {{ t('kanban.taskDetail.sections.assignedUsers.assignButton') }}

    </button>

  </div>

</template>



<script setup>

import { computed } from 'vue'

import { useI18n } from 'vue-i18n'

import { getUserDisplayName, getUserInitials, getUserPhotoUrl } from '@/utils/userDisplay'

import { findWorkspaceUser } from '@/utils/mapWorkspaceUsers'



const props = defineProps({

  workspaceUsers: { type: Array, default: () => [] },

  assignedIds: { type: Array, default: () => [] }

})



defineEmits(['remove', 'assign'])



const { t } = useI18n()



const resolvedUsers = computed(() => {

  return props.assignedIds.map((id) => {

    const raw = findWorkspaceUser(props.workspaceUsers, id)

    const user = raw || { id, usuarioId: id, nome: `#${id}` }

    return {

      id: Number(id),

      displayName: getUserDisplayName(user),

      initials: getUserInitials(user),

      photoUrl: getUserPhotoUrl(user)

    }

  })

})

</script>



<style scoped>

.cliente-assigned-users__row {

  display: flex;

  align-items: center;

  gap: 0.5rem;

  padding: 0.5rem;

  border-radius: 4px;

  border: 1px solid var(--border-primary);

  margin-bottom: 0.5rem;

}

.cliente-assigned-users__avatar-wrap {

  flex-shrink: 0;

}

.cliente-assigned-users__avatar {

  width: 2rem;

  height: 2rem;

  min-width: 2rem;

  border-radius: 4px;

  object-fit: cover;

  border: 2px solid var(--border-secondary);

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

}

.cliente-assigned-users__initials {

  display: flex;

  align-items: center;

  justify-content: center;

  background: linear-gradient(135deg, #3b82f6, #2563eb);

  color: #fff;

  font-size: 0.6875rem;

  font-weight: 600;

}

.cliente-assigned-users__name {

  flex: 1;

  font-size: 0.875rem;

  font-weight: 500;

  color: var(--text-primary);

}

.cliente-assigned-users__remove {

  padding: 0.25rem;

  border-radius: 4px;

  color: var(--error);

}

.cliente-assigned-users__remove:hover {

  background: var(--bg-hover);

}

.cliente-assigned-users__remove svg {

  width: 1rem;

  height: 1rem;

}

.cliente-assigned-users__empty {

  font-size: 0.875rem;

  color: var(--text-secondary);

  margin: 0 0 0.5rem;

}

.cliente-assigned-users__add {

  width: 100%;

  padding: 0.5rem;

  border: 2px dashed var(--border-primary);

  border-radius: 4px;

  font-size: 0.8125rem;

  color: var(--text-secondary);

  transition: border-color 0.15s, color 0.15s;

}

.cliente-assigned-users__add:hover {

  border-color: var(--info);

  color: var(--info);

}

</style>

